import React, { useState, ChangeEvent, FormEvent } from "react";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";

interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  phone: string;
  message: string;
}

const ContactForm: React.FC = () => {
  const [forms, setForms] = useState<ContactFormData>({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );

  // ✅ Handle form changes
  const changeHandler = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ): void => {
    const { name, value } = e.target;
    setForms((prev) => ({ ...prev, [name]: value }));

    // Real-time validation feedback
    validator.showMessageFor(name);
  };

  // ✅ Handle form submission
  const submitHandler = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    if (validator.allValid()) {
      toast.success("Your message has been sent successfully! 🎉");
      validator.hideMessages();

      // Reset form after submission
      setForms({
        name: "",
        email: "",
        subject: "",
        phone: "",
        message: "",
      });
    } else {
      validator.showMessages();
      toast.error("Please fill all required fields correctly!");
    }
  };

  return (
    <form onSubmit={submitHandler} className="contact-validation-active">
      <div className="row">
        {/* Name */}
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.name}
              type="text"
              name="name"
              onChange={changeHandler}
              placeholder="Your Name"
            />
            {validator.message("name", forms.name, "required|alpha_space")}
          </div>
        </div>

        {/* Email */}
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.email}
              type="email"
              name="email"
              onChange={changeHandler}
              placeholder="Your Email"
            />
            {validator.message("email", forms.email, "required|email")}
          </div>
        </div>

        {/* Phone */}
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.phone}
              type="tel"
              name="phone"
              onChange={changeHandler}
              placeholder="Your Phone"
            />
            {validator.message("phone", forms.phone, "required|numeric|min:6")}
          </div>
        </div>

        {/* Subject */}
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <select
              name="subject"
              value={forms.subject}
              onChange={changeHandler}
            >
              <option value="">Select a Service</option>
              <option value="Photography">Photography</option>
              <option value="Rehearsal Dinner">Rehearsal Dinner</option>
              <option value="Afterparty">Afterparty</option>
              <option value="Videographers">Videographers</option>
              <option value="Perfect Cake">Perfect Cake</option>
              <option value="All Of The Above">All Of The Above</option>
            </select>
            {validator.message("subject", forms.subject, "required")}
          </div>
        </div>

        {/* Message */}
        <div className="col col-lg-12 col-12">
          <div className="form-field">
            <textarea
              value={forms.message}
              name="message"
              onChange={changeHandler}
              placeholder="Message"
            />
            {validator.message("message", forms.message, "required|min:10")}
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="submit-area">
        <button type="submit" className="theme-btn">
          Submit Now
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
